var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import useLocalStorage from '@hooks/useLocalStorage';
const themeCustomizationContext = React.createContext({
    activeColorScale: 'primary',
    setActiveColorScale: (_colorScale) => { },
    activeRadiusScale: 'none',
    setActiveRadiusScale: (_radiusScale) => { },
    activeFont: 'Inter',
    setActiveFont: (_font) => { },
});
function useSettingsProvider() {
    const [activeColorScale, setActiveColorScale] = useLocalStorage('active-color', 'primary');
    const [activeRadiusScale, setActiveRadiusScale] = useLocalStorage('active-radius', 'md');
    const [activeFont, setActiveFont] = useLocalStorage('active-font', 'Inter');
    return {
        activeColorScale,
        setActiveColorScale,
        activeRadiusScale,
        setActiveRadiusScale,
        activeFont,
        setActiveFont,
    };
}
export function ThemeCustomizationProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const settings = useSettingsProvider();
    return (_jsx(themeCustomizationContext.Provider, Object.assign({ value: settings }, props, { children: children })));
}
// Hook that enables any component to subscribe to customization state
export const useThemeCustomization = () => {
    return React.useContext(themeCustomizationContext);
};
